<template>
  <v-app id="onHuov">

    <defNavBar title="Ares - Rental contract" :actions="huov.action_items" :accolist="true" :home="true" :attms="huov.attm_aant" :notts="huov.nott_aant" @actionClick="actionClick" />

    <v-main>
      <v-container fluid>
        <v-row>

          <v-col cols="12" lg="6" class="px-1">
            <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                      <v-form ref="huovCard1">
                        <v-card-title>
                          <v-row nu-gutters dense class="mt-1">
                            <v-col cols="9">
                              <div style="display: flex; flex-direction: row; align-items: flex-start; flex-wrap: nowrap;">
                                <div style="flex-shrink: 0; margin-right: 16px;">
                                  {{ huov.hust_oms }} {{ huov.huov_code }}
                                </div>
                                <div style="flex-shrink: 0; display: flex; align-items: center; margin-right: 16px;">
                                  <v-chip :color=huov.hust_kleur class="mr-2"><span style="color: black !important;">{{huov.hust_code}}</span></v-chip>
                                  <v-chip v-if="huov.huov_type==='Test'" class="grid-item-warning-test"> {{huov.huov_type}} </v-chip>
                                </div>
                                <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; flex: 1;">
                                  <v-tooltip bottom v-if="huov.hasComplaint">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-error" v-on="on" v-bind="attrs"><v-icon size="21" color="red">mdi-thumb-down-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Complaint</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasDamages">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-warning" v-on="on" v-bind="attrs"><v-icon size="22" color="orange">mdi-glass-fragile</v-icon></v-avatar>
                                    </template>
                                    <span>Damages</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasOpenChange">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-change" v-on="on" v-bind="attrs"><v-icon size="22" color="orange">mdi-home-alert-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Open change</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasRebooking">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-rebooking" v-on="on" v-bind="attrs"><v-icon size="22" color="blue">mdi-home-switch-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Rebooking</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasGoodReview">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-ok" v-on="on" v-bind="attrs"><v-icon size="21" color="green">mdi-message-processing-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Good review</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasModerateReview">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-warning" v-on="on" v-bind="attrs"><v-icon size="21" color="orange">mdi-message-processing-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Moderate review</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasBadReview">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-error" v-on="on" v-bind="attrs"><v-icon size="21" color="red">mdi-message-processing-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Bad review</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.hasCancellationInsurance">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-ok" v-on="on" v-bind="attrs"><v-icon size="22" color="success">mdi-anchor</v-icon></v-avatar>
                                    </template>
                                    <span>Cancellation insurance</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.under_occupancy">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-warning" v-on="on" v-bind="attrs"><v-icon size="22" color="warning">mdi-account-alert-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Under occupancy</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.under_occupancy_ok">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-rebooking" v-on="on" v-bind="attrs"><v-icon size="22" color="blue">mdi-account-alert-outline</v-icon></v-avatar>
                                    </template>
                                    <span>Under occupancy is ok by guest</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="huov.refundable_text !==''">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-avatar size="30" class="grid-item-rebooking avatar-refund" v-on="on" v-bind="attrs">R</v-avatar>
                                    </template>
                                    <span>Refundable</span>
                                  </v-tooltip>
                                </div>
                                <v-btn v-if="huov.inpt_naam === 'Booking.com' && huov.show_dev_options" class="primary ma-1" small v-on:click="$refs.huovOtaBooking.open(huov.huov_encrid)"><v-icon color="white" left>mdi-briefcase</v-icon> Booking.com</v-btn>
                              </div>
                            </v-col>
<!-- experation date option starts here -->                            
                            <v-col cols="3" class="ml-4" v-if="huov.huov_optie_verval_dt > ''">
                              <v-text-field v-model="huov.huov_optie_verval_dt" readonly label="Expire date / time" dense>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-title>
<!--booking (general) starts here-->
                        <v-row no-gutters class="mt-4">
                          <v-col cols="2"  class="ml-4 pr-2">
                            <v-text-field v-model="huov.huov_dt" readonly label="Booking date" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="3" class="pr-2">
                            <v-text-field v-model="huov.gebr_code_nw" readonly label="Booked by" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="pr-2">
                            <v-text-field @click="$refs.huovInpt.open(huov.huov_encrid);" v-model="huov.inpt_naam"
                              readonly :disabled="!huov.inpt_update_allowed" label="Sales partner / website" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="3" class="pr-2" v-if="huov.huov_ota_code > ''">
                            <v-text-field v-model="huov.huov_ota_code"
                              @click="$refs.huovOtaCode.open(huov.huov_encrid);" readonly
                              label="Sales partner booking ID" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2">
                            <v-tooltip bottom v-if="huov.inpt_change_requests">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" v-bind="attrs" v-on="on" x-small fab @click="$refs.huovAirbnbAlterationReq.open(huov.huov_encrid);"><v-icon>mdi-swap-horizontal</v-icon></v-btn>  
                              </template>
                              <span>Airbnb change requests</span>
                            </v-tooltip>
                            
                            <btn_audit table="huov" :encrid="huov.huov_encrid" :size=30 tooltip="audit of rental contract"/>
                              
                          </v-col>
                        </v-row>
<!--cancellation starts here-->
                        <v-row v-if="typeof huov.huov_ann_dt !== 'undefined'" no-gutters>
                          <v-col cols="3" class="ml-4 pr-2">
                            <v-text-field v-model="huov.huov_ann_dt" readonly label="Cancellation date" dense class="text_markup">
                            </v-text-field>
                          </v-col>
                          <v-col cols="2" class="pr-2">
                            <v-text-field v-model="huov.huov_ann_schuld" readonly label="Initiated" dense class="text_markup">
                            </v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field v-model="huov.gebr_code_ann" readonly label="Cancelled by" dense class="text_markup">
                            </v-text-field>
                          </v-col>
                        </v-row>
<!--arrival/departure starts here-->
                        <v-row no-gutters>
                          <v-col cols="5"  class="ml-4 pr-2">
                            <v-text-field @click="$refs.huovArrDep.open(huov.huov_encrid);"
                              v-model="huov.huov_van_samengesteld" readonly label="Arrival" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="5" class="pr-2">
                            <v-text-field @click="$refs.huovArrDep.open(huov.huov_encrid);"
                              v-model="huov.huov_tm_samengesteld" readonly label="Departure" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2">
                            <v-text-field v-model="huov.huov_aant_nacht" readonly label="Nights" dense class="text_markup"></v-text-field>
                          </v-col>
                        </v-row>
<!--travel party starts here-->
                        <v-row no-gutters>
                          <v-col cols="1"  class="ml-4 pr-2">
                            <v-text-field @click="$refs.huovTravelPartyComposition.open(huov.huov_encrid);"
                              v-model="huov.huov_aant_volw" readonly label="Adults" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2">
                            <v-text-field @click="$refs.huovTravelPartyComposition.open(huov.huov_encrid);"
                              v-model="huov.huov_aant_kind" readonly label="Children" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2">
                            <v-text-field @click="$refs.huovTravelPartyComposition.open(huov.huov_encrid);"
                              v-model="huov.huov_aant_baby" readonly label="Babies" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2">
                            <v-text-field @click="$refs.huovTravelPartyComposition.open(huov.huov_encrid);"
                              v-model="huov.huov_aant_hd" readonly label="Pets" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="1" class="pr-2 row-pointer">
                             <v-avatar :color="huov.huov_hogs_color" size=30 @click="$refs.huovTravelParty.open(huov.huov_encrid);">{{ huov.huov_aant_hogs }}</v-avatar>  
                          </v-col>
<!--handling starts here-->                          
                          <v-col cols="2" class="pr-2">
                            <v-text-field @click="$refs.huovHandling.open(huov.huov_encrid);"
                              v-model="huov.huov_handling_verk" readonly label="VFY handles Guest" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="pr-2">
                            <v-text-field @click="$refs.huovHandling.open(huov.huov_encrid);"
                              v-model="huov.huov_handling_ink" readonly label="VFY handles Hosts" dense class="text_markup"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="pr-2">
                            <v-text-field @click="$refs.huovHandling.open(huov.huov_encrid);"
                              v-model="huov.huov_review_send" readonly label="Send review" dense class="text_markup"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <div class="d-flex align-start pl-6 pb-4 pr-6" style="width: 100% !important;" v-if="huov.under_occupancy_ok||huov.under_occupancy">
                            <div v-if="huov.under_occupancy_ok" style="color: dodgerblue; background-color: rgba(30, 144, 255, 0.2); border: 1px solid dodgerblue; border-radius: 8px; padding: 10px; display: flex; align-items: flex-start; width: 100%;">
                              <v-icon color="blue" size="24" class="mr-4">mdi-information</v-icon>
                              <div>Under-occupancy. There are <span>{{ huov.num_persons }}</span> guests for a capacity of <span>{{ huov.max_persons }}</span> people. The guest indicated on {{ $moment(huov.under_occupancy_ok_dt).format("DD-MM-YYYY HH:mm") }} that this is indeed correct.</div>
                            </div>
                            <div v-if="huov.under_occupancy&&!isBookingOngoingOrCompleted()" style="color: orange; background-color: rgba(255, 165, 0, 0.2); border: 1px solid orange; border-radius: 8px; padding: 10px; display: flex; align-items: flex-start; width: 100%;">
                              <v-icon color="orange" size="24" class="mr-4">mdi-alert</v-icon>
                              <div>Under-occupancy. There are <span>{{ huov.num_persons }}</span> guests for a capacity of <span>{{ huov.max_persons }}</span> people. Guest has not verified.</div>
                              <v-btn class="primary ml-auto" style="margin-top: 2px;" x-small @click="approveUnderOccupancy(huov.huov_encrid)">occupancy is correct</v-btn>
                            </div>
                          </div>
                        </v-row>
                        <v-row v-if="huov.inpt_code && huov.inpt_code==='chaletnl'">
                          <div class="d-flex align-start pl-6 pb-4 pr-6" style="width: 100% !important;">
                            <div style="color: red; background-color: rgba(255, 0, 0, 0.2); border: 1px solid red; border-radius: 8px; padding: 10px; display: flex; align-items: flex-start; width: 100%;">
                              <v-icon color="red" size="24" class="mr-4">mdi-alert-circle</v-icon>
                              <div v-html="'This is a <b>Chalet.nl</b> booking. Guests <b>ARE NOT TO BE CONTACTED</b> directly by Villa for You team members'"></div>
                            </div>
                          </div>
                        </v-row>
                        <v-row v-if="huov.show_operto_fewo">
                          <div class="pl-6 pb-4 pr-6" style="width: 100% !important;">
                            <table style="font-size: 13px;">
                              <tr>
                                <th></th>
                                <th class="pr-6 text-left">Operto</th>
                                <th class="text-left">Fewoflow</th>
                              </tr>
                              <tr>
                                <td class="pr-4">Booking</td>
                                <td class="pr-6">{{ huov.operto_id }}</td>
                                <td>{{ huov.fewoflow_id }}</td>
                              </tr>
                              <tr>
                                <td class="pr-4">Planning</td>
                                <td class="pr-6">{{ huov.plan_operto_id }}</td>
                                <td>{{ huov.plan_fewoflow_id }}</td>
                              </tr>
                            </table>
                          </div>
                        </v-row>
                      </v-form>
                  </v-card>
                </v-col>
              </v-row>

<!-- in case of purchase partner -->
              <v-row v-if="huov.pp_bookingcode!==''">
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-card-title>Purchase partner info</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="4" class="ml-4">
                        <v-text-field v-model="huov.pp_bookingcode" readonly label="Booking number" dense>
                        </v-text-field>
                      </v-col>
                      <v-col cols="3" class="ml-4">
                        <v-text-field v-model="huov.pp_parkname" readonly label="Parc" dense>
                        </v-text-field>
                      </v-col>                      
                      <v-col cols="2" class="ml-4">
                        <v-text-field v-model="huov.pp_connectionname" readonly label="Connection" dense>
                        </v-text-field>
                      </v-col>                      
                      <v-col cols="2" class="ml-4">
                        <v-text-field v-model="huov.pp_connectiontype" readonly label="Type" dense>
                        </v-text-field>
                      </v-col>                      
                    </v-row>
                  </v-card>  
                </v-col>
              </v-row>
 
<!--customer starts here-->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                      <v-card-title>Guest<v-spacer></v-spacer> <div style="display: flex; flex-direction: row; align-items: center;"><v-btn class="primary ma-2" x-small @click="loginMyBooking(huov.klnt_encrid)">show in MyBooking</v-btn><v-btn class="primary ma-2" x-small @click="copyUrlToClipboard(huov.my_booking_url)">copy current MyBooking URL to clipboard</v-btn><div style="width: 50px; font-size: small;">{{ isCopied }}</div></div></v-card-title>

                      <v-row no-gutters>
                        <v-col cols="1" class="ml-4 pr-2">
                          <v-text-field v-model="huov.klnt_code"  @click="$router.open('/klnt/onKlnt/' + huov.klnt_encrid)" readonly label="code" dense class="text_markup">
                          </v-text-field>
                        </v-col>                        
                        <v-col cols="5" class="pr-2">
                          <v-text-field v-model="huov.klnt_naam"
                            @click="$router.open('/klnt/onKlnt/' + huov.klnt_encrid)" readonly label="Name" dense class="text_markup">
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="1" class="ml-4 pr-2">
                        </v-col>                         
                        <v-col cols="5">
                          <v-text-field v-model="huov.klnt_adres" readonly label="Address" dense class="pr-2 text_markup"></v-text-field>
                        </v-col>                        
                        <v-col cols="4" >
                          <v-text-field v-model="huov.klnt_tel1" readonly label="Telephone 1" dense class="text_markup"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="1" class="ml-4 pr-2">
                        </v-col>       
                        <v-col cols="8" class="pr-2">
                          <v-text-field v-model="huov.klnt_email" readonly label="Email" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="1" >
                          <v-text-field v-model="huov.klnt_taal_code" readonly label="Language" dense class="text_markup"></v-text-field>
                        </v-col>
                      </v-row>
                  </v-card>
                </v-col>
              </v-row>
<!--accommodation starts here-->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                      <v-card-title>Accommodation</v-card-title>

                      <v-row no-gutters @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                        <v-col cols="4" class="pl-4 pr-2">
                          <v-text-field v-model="huov.huis_code" readonly label="Acco" dense class="logo_row_2 text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pr-2">
                          <v-text-field v-model="huov.huis_naam" readonly label="Name" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pr-2">
                          <v-text-field v-model="huov.huis_plaats" readonly label="Location" dense class="text_markup"></v-text-field>
                        </v-col>
                      
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="1" class="pl-4" @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                          <v-text-field v-model="huov.huis_aantpers_max" readonly label="Pers.max" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pl-2 pr-2" @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                          <v-text-field v-model="huov.huis_aantbaby_max" readonly label="Baby.extra" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pr-4" @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                          <v-text-field v-model="huov.huis_aantpets_max" readonly label="Pets.max" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="4" offset="1" class="pr-2" @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                          <v-text-field v-model="huov.cttptaal_oms" readonly label="Contract" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pr-2">
                          <v-text-field readonly v-model="huov.vat_appl" :label="huov.vat_label" dense class="text_markup"></v-text-field>
                        </v-col>                        
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="3" class="pl-4">
                        </v-col>
                        <v-col cols="3" offset="1" class="pr-2" @click="$router.open('/huis/onHuis/' + huov.huis_encrid)">
                          <v-text-field v-model="huov.product_partner.ikpt_naam" readonly label="Product Partner" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="1" class="pr-2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                            </template>
                            <span v-html="huov.product_partner.ikpt_info"></span>
                          </v-tooltip> 
                        </v-col>                        
                        <v-col cols="4" class="pr-2">
                        </v-col>                       
                      </v-row>

                      <br>
<!--hoct starts here-->                      
                      <v-row v-for="(hoctRecord,i) in huov.hoct" :key="i" no-gutters dense>
                        <v-col cols="1" class="pl-4 pr-2">
                          <v-text-field v-model="hoctRecord.eign_code"  @click="$router.open('/eign/onEign/' + hoctRecord.eign_encrid)" readonly label="code" dense class="text_markup">
                          </v-text-field>
                        </v-col>
                        <v-col cols="2" class="pr-2">
                          <v-text-field v-model="hoctRecord.hoct_rol" readonly label="Role" dense class="text_markup"></v-text-field>
                        </v-col>
                        <v-col cols="3" class="pr-2">
                          <v-text-field v-model="hoctRecord.eign_naam" @click="$router.open('/eign/onEign/' + hoctRecord.eign_encrid)" readonly label="Name" dense class="text_markup">
                          </v-text-field>
                        </v-col>
                        <v-col cols="1" class="pr-2">
                          <v-text-field v-model="hoctRecord.eign_taal_code" readonly label="Language" dense class="text_markup">
                          </v-text-field>
                        </v-col>
                        <v-col cols="2" class="pr-2">
                          <v-text-field v-model="hoctRecord.eign_tel1_vcs" readonly label="Telephone" dense class="text_markup">
                          </v-text-field>
                        </v-col>
                        <v-col cols="3" class="pr-2">
                          <v-text-field v-model="hoctRecord.eign_email" readonly label="Email" dense class="text_markup"></v-text-field>
                        </v-col>
                      </v-row>         

                  </v-card>
                </v-col>
              </v-row>
<!--hoct ends here-->                           
<!-- damages v2 start here -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <huov_hosm :huov_encrid="huov_encrid" @updateData="updateData"/>
                </v-col>
              </v-row>    
<!-- damages v2 stops here -->
<!-- complaints start here -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <huov_hokl :huov_encrid="huov_encrid" @updateData="updateData"/>
                </v-col>
              </v-row>    
<!-- complaints stops here -->
<!-- rebookings start here -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <huov_homb :huov_encrid="huov_encrid" @updateData="updateData"/>
                </v-col>
              </v-row>    
<!-- rebookings stops here -->
<!-- changes start here -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <huov_howz :huov_encrid="huov_encrid" @updateData="updateData"/>
                </v-col>
              </v-row>    
<!-- changes stops here -->
<!-- review HOGR starts here -->        
            <v-row>
              <v-col cols="12" class="px-1">
                <v-card>
                  <v-card-title>Review</v-card-title>    
                  <v-row no-gutters v-if="getArrayLength(this.huov_hogr) > 0">
                    <v-col cols="12" class="px-2">
                      <v-data-table 
                        class="elevation-1" 
                        dense 
                        :headers="getHogrHeaders()" 
                        :items="huov_hogr"
                        :disable-pagination=true 
                        hide-default-footer 
                        item-key="hogr_encrid">
                        <template v-slot:item="hogr">
                          <tr style="padding: 10px;">
                            <td class="td_markup">{{$moment(hogr.item.revw_date_created).format("DD-MM-YYYY HH:mm")}}</td>
                            <td class="td_markup">{{hogr.item.assigned_display_name}}</td>                      
                            <td class="td_markup score">
                              <v-layout justify-center>
                                <v-avatar size="30" :color="hogr.item.revw_score_color"><b>{{hogr.item.revw_score}}</b></v-avatar>
                              </v-layout>
                            </td>
                            <td class="td_markup">
                              <v-layout justify-center>{{hogr.item.revw_language_code}}</v-layout>
                            </td>
                            <td class="td_markup">
                              <v-layout justify-start>{{hogr.item.revw_text | max_char(125)}}
                                <v-spacer></v-spacer>
                                <span v-if="hogr.item.revw_text!=''">
                                  <v-avatar v-on:click="showReaction('hogr', hogr.item.hogr_encrid, 'Review', 'GuestBook')" size="30" color="white" class="ml-3 logo_row_2">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                  </v-avatar>
                                </span>
                              </v-layout>
                            </td>
                            <td class="td_markup">{{hogr.item.status}}</td>
                            <td class="td_markup">
                              <v-layout justify-center>
                                <span v-if="hogr.item.revw_reaction">
                                  <v-avatar v-on:click="showReaction('hogr', hogr.item.hogr_encrid, 'Reaction VFY', 'ReactionVFY')" size="30" color="white" class="logo_row_2">
                                    <v-icon color="success">mdi-check-bold</v-icon>
                                  </v-avatar>
                                </span>
                                <span v-else>
                                  <v-avatar size="30" color="transparant" class="logo_row_2"></v-avatar>
                                </span>
                              </v-layout>
                            </td>
                            <td class="td_markup">
                              <v-avatar v-on:click="showReview(hogr.item)" size="30" color="white" class="ml-3 logo_row_2">
                                <v-icon medium>mdi-playlist-edit</v-icon>
                              </v-avatar>
                            </td>                              
                          </tr>                        
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
<!-- review REVW starts here -->                          
                  <v-row no-gutters v-if="getArrayLength(this.huov_revw) > 0">
                    <v-col cols="12" class="px-2">
                      <v-data-table 
                        class="elevation-1" 
                        dense 
                        :headers="getHogrHeaders()" 
                        :items="huov_revw"
                        :disable-pagination=true 
                        hide-default-footer 
                        item-key="revw_encrid">
                        <template v-slot:item="revw">
                          <tr style="padding: 10px;">
                            <td class="td_markup">{{$moment(revw.item.revw_date_created).format("DD-MM-YYYY HH:mm")}}</td>
                            <td class="td_markup">{{revw.item.assigned_display_name}}</td>                      
                            <td class="td_markup score">
                              <v-layout justify-center>
                                <v-avatar size="30" :color="revw.item.revw_score_color"><b>{{revw.item.revw_score}}</b></v-avatar>
                              </v-layout>
                            </td>
                            <td class="td_markup">
                              <v-layout justify-center>{{revw.item.revw_language_code}}</v-layout>
                            </td>
                            <td class="td_markup">
                              <v-layout justify-start>{{revw.item.revw_text | max_char(125)}}
                                <v-spacer></v-spacer>
                                <span v-if="revw.item.revw_text!=''">
                                  <v-avatar v-on:click="showReaction('revw', revw.item.revw_encrid, 'Review', 'GuestBook')" size="30" color="white" class="ml-3 logo_row_2">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                  </v-avatar>
                                </span>
                              </v-layout>
                            </td>
                            <td class="td_markup">{{revw.item.status}}</td>
                            <td class="td_markup">
                              <v-layout justify-center>
                                <span v-if="revw.item.revw_reaction">
                                  <v-avatar v-on:click="showReaction('revw', revw.item.revw_encrid, 'Reaction VFY', 'ReactionVFY')" size="30" color="white" class="logo_row_2">
                                    <v-icon color="success">mdi-check-bold</v-icon>
                                  </v-avatar>
                                </span>
                                <span v-else>
                                  <v-avatar size="30" color="transparant" class="logo_row_2"></v-avatar>
                                </span>
                              </v-layout>
                            </td>
                            <td class="td_markup">
                              <v-avatar v-on:click="showReview(revw.item)" size="30" color="white" class="ml-3 logo_row_2">
                                <v-icon medium>mdi-playlist-edit</v-icon>
                              </v-avatar>
                            </td>                              
                          </tr>                        
                        </template>
                      </v-data-table>
                    </v-col>                    
                  </v-row> 
<!-- NO review starts here -->                          
                  <div v-if="getArrayLength(this.huov_revw) === 0 && getArrayLength(this.huov_hogr) === 0">
                    <v-list-item>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-label>No review submitted</v-label>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </div>                         
                  <v-row dense>
                    <v-col></v-col>
                  </v-row>                  
                  <show_text ref="showtext" />
                  <showReview ref="showreview" />                  
                </v-card>
              </v-col>
            </v-row>                 
<!-- einde reviews -->

            </v-container>
          </v-col>

          <v-col cols="12" lg="6" class="px-1">
<!-- Rechts -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-card-title>Price calculation explanation
                      <v-spacer></v-spacer>
                      <v-btn class="primary ma-2" x-small
                        @click="$router.open('/huov/huovPrijsUitleg/' + huov.huov_encrid)">Show</v-btn>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

<!-- guest financial lines -->
              <v-row v-for="(hklrKlntRecord,k1) in huov.hklr_klnt" :key="k1">
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Guest {{hklrKlntRecord.klnt_code}} {{hklrKlntRecord.klnt_naam}}

                      <v-menu v-if="hklrKlntRecord.klnt_action_items.length > 0" offset-y open-on-hover close-on-click>
                        <template v-slot:activator="{ on }">
                          <v-btn class="primary ma-2" x-small v-on="on">Action</v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item v-for="klnt_action_item in hklrKlntRecord.klnt_action_items"
                            :key="klnt_action_item.text"
                            @click="klntActionClick(klnt_action_item.action,hklrKlntRecord.huov_encrid)">
                            <v-list-item-title>{{ klnt_action_item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <btn_audit table="hklr" :encrid="huov.huov_encrid" :size=30 tooltip="audit of lines, points and credits"/>
                      <!-- <btn_audit table="kltg" :encrid="huov.klnt_encrid" :size=30 tooltip="audit of credits"/>
                      <btn_audit table="klpt" :encrid="huov.klnt_encrid" :size=30 tooltip="audit of points"/> -->
                      <div class="ml-8 refundable-text" v-if="huov.refundable_text">{{huov.refundable_text}}</div>
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>
                        </thead>


                        <tbody>

                          <tr v-for="(hklrRecord,k2) in hklrKlntRecord.hklr" :key="k2">
                            <td style="vertical-align: top;"> {{hklrRecord.hklr_dt}} </td>
                            <td style="vertical-align: top;">
                              <div>
                                {{hklrRecord.fctitaal_oms}} 
                                <span v-if="hklrRecord.hkrd.length>0">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon small>mdi-information-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    <span v-html="makeHkrdTable(hklrRecord.hkrd)">
                                    </span>
                                  </v-tooltip>
                                </span>
                              </div>
                              <!-- <div v-if="hklrRecord.hkrd.length>0">
                                 <div v-for="(hkrdRecord, k3) in hklrRecord.hkrd" :key="k3">
                                    <v-row no-gutters>
                                      <v-col cols="6" class="pl-5 pr-1 font-weight-light">{{ hkrdRecord.hkrd_oms }}</v-col>
                                      <v-col cols="6" class="pl-1 pr-0 font-weight-light" align="right">{{ hkrdRecord.hkrd_line }}</v-col>
                                    </v-row>                                 
                                  </div>
                              </div> -->
                            </td>
                            <td align="right" style="vertical-align: top">{{hklrRecord.hklr_line }}</td>
                            <td align="right" style="vertical-align: top">{{hklrRecord.hklr_payment}}</td>
                            <td style="vertical-align: top">
                              <v-btn v-if="hklrRecord.hklr_rm === 'Yes'" text icon
                                @click="rmHklr(hklrRecord.hklr_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="hklrRecord.klpt_rm === 'Yes'" text icon
                                @click="rmKlpt(hklrRecord.klpt_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="hklrRecord.kltg_rm === 'Yes'" text icon
                                @click="rmKltg(hklrRecord.kltg_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>

                          <tr>
                            <td colspan=5></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>Balance {{hklrKlntRecord.hklr_balance}}</b></td>
                            <td align="right"><b>{{hklrKlntRecord.hklr_line_total}}</b></td>
                            <td align="right"><b>{{hklrKlntRecord.hklr_payment_total}}</b></td>
                            <td></td>
                          </tr>
                          <tr v-if="hklrKlntRecord.hklr_payment_via_partner >''">
                            <td colspan=3><b>{{hklrKlntRecord.hklr_payment_via_partner}}</b></td>
                            <td colspan=2></td>
                          </tr>
                          <tr>
                            <td>Payment term 1</td>
                            <td>{{hklrKlntRecord.hklr_term1_dt}}</td>
                            <td align="right">{{hklrKlntRecord.hklr_term1_bedrag}}</td>
                            <td colspan=2></td>
                          </tr>
                          <tr v-if="hklrKlntRecord.hklr_term2_dt >''">
                            <td>Payment term 2</td>
                            <td>{{hklrKlntRecord.hklr_term2_dt}}</td>
                            <td align="right">{{hklrKlntRecord.hklr_term2_bedrag}}</td>
                            <td colspan=2></td>
                          </tr>
                          <tr v-if="hklrKlntRecord.hklr_rem >''">
                            <td>Payment reminder(s)</td>
                            <td v-if="hklrKlntRecord.hklr_rem_ongoing > 0">
                              <v-chip :color=hklrKlntRecord.hklr_rem_ongoing_color> Ongoing:
                                {{hklrKlntRecord.hklr_rem_ongoing}} </v-chip>
                            </td>
                            <td v-if="hklrKlntRecord.hklr_rem_ended > 0">
                              Ended: {{hklrKlntRecord.hklr_rem_ended}}
                            </td>                  
                            <td></td>
                            <td></td>                                      
                            <td></td>
                          </tr>
                          <tr v-if="huov.hasCancellationInsurance">
                            <td>Cancellation insurance</td>
                            <td><v-icon color="success">mdi-check-bold</v-icon></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr v-if="declinedCancellationInsurance">
                            <td>Cancellation insurance declined</td>
                            <td>
                              <div style="display: flex; flex-direction: row; align-items: center;">
                                <v-checkbox 
                                  v-model="huov.declinedCancellationInsurance" 
                                  dense 
                                  hide-details 
                                  color="primary" 
                                  class="pb-1"
                                  :ripple="false"
                                  :disabled="processing"
                                  @change="handleDeclinedCancellationInsuranceChange()">
                                </v-checkbox>
                                <div style="font-weight: 800; margin-left: 5px; padding-top: 6px;">{{ xdots }}</div>
                              </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>                          
                        </tbody>

                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              
<!-- host (hoct) financial lines -->

              <v-row v-for="(hctrEignRecord,k5) in huov.hctr_eign" :key="hctrEignRecord+k5">
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Host {{hctrEignRecord.eign_code}} {{hctrEignRecord.eign_naam}}

                      <v-menu v-if="hctrEignRecord.hoct_action_items.length > 0" offset-y open-on-hover close-on-click>
                        <template v-slot:activator="{ on }">
                          <v-btn class="primary ma-2" x-small v-on="on">Action</v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item v-for="hoct_action_item in hctrEignRecord.hoct_action_items"
                            :key="hoct_action_item.text"
                            @click="hoctActionClick(hoct_action_item.action,hctrEignRecord.hoct_encrid)">
                            <v-list-item-title>{{ hoct_action_item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <btn_audit table="hctr" :encrid="hctrEignRecord.hoct_encrid" :size=30 tooltip="audit of host lines"/>
                      <div class="subtitle-1"> (IBAN: {{hctrEignRecord.hoct_iban}} ) </div>
                      <v-spacer></v-spacer>
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead v-if="hctrEignRecord.hctr.length">
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(hctrRecord,k6) in hctrEignRecord.hctr" :key="k6">
                            <td> {{hctrRecord.hctr_dt}} </td>
                            <td>{{hctrRecord.fctitaal_oms}}</td>
                            <td align="right">{{hctrRecord.hctr_line }}</td>
                            <td align="right">{{hctrRecord.hctr_payment }}</td>
                            <td>
                              <v-btn v-if="hctrRecord.hctr_rm === 'Yes'" text icon
                                @click="rmHctr(hctrRecord.hctr_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan=5></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>{{hctrEignRecord.hctr_balance}}</b></td>
                            <td align="right"><b>{{hctrEignRecord.hctr_line_total}}</b></td>
                            <td align="right"><b>{{hctrEignRecord.hctr_payment_total}}</b></td>
                            <td></td>
                          </tr>
                          <tr v-if="hctrEignRecord.hctr_term1_dt > ''">
                            <td>Payment Term 1 </td>
                            <td>{{hctrEignRecord.hctr_term1_dt}}</td>
                            <td align="right">{{hctrEignRecord.hctr_term1_bedrag}}</td>
                            <td></td>
                          </tr>
                          <tr v-if="hctrEignRecord.hctr_term2_dt >''">
                            <td>Payment term 2</td>
                            <td>{{hctrEignRecord.hctr_term2_dt}}</td>
                            <td align="right">{{hctrEignRecord.hctr_term2_bedrag}}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <addHklr ref="addHklr"></addHklr>
              <transferKlpt ref="transferKlpt"></transferKlpt>
              <rmHklr ref="rmHklr"></rmHklr>
              <rmKlpt ref="rmKlpt"></rmKlpt>
              <rmKltg ref="rmKltg"></rmKltg>
              <showHobo ref="showHobo"></showHobo>
              <showHklrHkgm ref="showHklrHkgm"></showHklrHkgm>
              <showHsprHpgm ref="showHsprHpgm"></showHsprHpgm>
              <showHagrHagm ref="showHagrHagm"></showHagrHagm>
              <updHklrTerms ref="updHklrTerms"></updHklrTerms>
              <addHctr ref="addHctr"></addHctr>
              <updHoctTerms ref="updHoctTerms"></updHoctTerms>
              <rmHctr ref="rmHctr"></rmHctr>
              <showHctrHcgm ref="showHctrHcgm"></showHctrHcgm>

<!-- additional costs lines -->

              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Additional costs <v-btn class="primary ma-2" x-small @click="addHokp(huov.huov_encrid)">Add Costs</v-btn>
                        <btn_audit table="hokp" :encrid="huov.huov_encrid" :size=30 tooltip="audit of additional costs"/>
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody v-for="(hokpRecord,k9) in huov.AdditionalCosts" :key="k9">
                          <tr>
                            <td>{{hokpRecord.ktpttaal_oms}}</td>
                            <td>{{hokpRecord.hokp_betaling}}</td>
                            <td>{{hokpRecord.hokp_oms}}</td>
                            <td>
                              <v-btn text icon @click="rmHokp(hokpRecord.hokp_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

<!-- service on site financial lines -->

              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Service on Site <v-btn class="primary ma-2" x-small @click="addHokp(huov.huov_encrid)">Add Costs</v-btn>
                        <btn_audit table="hokp" :encrid="huov.huov_encrid" :size=30 tooltip="audit of service on site"/>
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody v-for="(hokpRecord,k10) in huov.ServiceOnSite" :key="k10">
                          <tr>
                            <td>{{hokpRecord.ktpttaal_oms}}</td>
                            <td>{{hokpRecord.hokp_betaling}}</td>
                            <td>{{hokpRecord.hokp_oms}}</td>
                            <td>
                              <v-btn text icon @click="rmHokp(hokpRecord.hokp_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <rmHokp ref="rmHokp"></rmHokp>
              <addHokp ref="addHokp"></addHokp>



<!-- Sales Partner financial lines -->
            <div v-if="huov.hspr_inpt.length > 0">
              <v-row v-for="(hsprInptRecord,k1) in huov.hspr_inpt" :key="k1">
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Sales Partner {{hsprInptRecord.inpt_code}} {{hsprInptRecord.inpt_naam}}
                      
                      <v-menu v-if="hsprInptRecord.inpt_action_items.length > 0" offset-y open-on-hover close-on-click>
                        <template v-slot:activator="{ on }">
                          <v-btn class="primary ma-2" x-small v-on="on">Action</v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item v-for="inpt_action_item in hsprInptRecord.inpt_action_items"
                            :key="inpt_action_item.text"
                            @click="inptActionClick(inpt_action_item.action,hsprInptRecord.huov_encrid)">
                            <v-list-item-title>{{ inpt_action_item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    
                      <btn_audit table="hspr" :encrid="huov.huov_encrid" :size=30 tooltip="audit of lines"/>
                      
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>
                        </thead>


                        <tbody>

                          <tr v-for="(hsprRecord,k2) in hsprInptRecord.hspr" :key="k2">
                            <td> {{hsprRecord.hspr_dt}} </td>
                            <td>{{hsprRecord.fctitaal_oms}}</td>
                            <td align="right" style="vertical-align: top">{{hsprRecord.hspr_line }}</td>
                            <td align="right" style="vertical-align: top">{{hsprRecord.hspr_payment}}</td>
                            <td style="vertical-align: top">
                              <v-btn v-if="hsprRecord.hspr_rm === 'Yes'" text icon
                                @click="rmHspr(hsprRecord.hspr_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan=5></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>Balance {{hsprInptRecord.hspr_balance}}</b></td>
                            <td align="right"><b>{{hsprInptRecord.hspr_line_total}}</b></td>
                            <td align="right"><b>{{hsprInptRecord.hspr_payment_total}}</b></td>
                            <td></td>
                          </tr>
                        </tbody>

                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <addHspr ref="addHspr"></addHspr>
              <rmHspr ref="rmHspr"></rmHspr>
            </div>
            <!-- hagr -->
            <div v-if="huov.hagr_eign.length > 0">
              <v-row v-for="(hagrEignRecord, k1) in huov.hagr_eign" :key="k1">
                <v-col cols="12" class="px-1">
                  <v-card>

                    <v-card-title>Agent {{hagrEignRecord.eign_code}} {{hagrEignRecord.eign_naam}}

                      <v-menu v-if="hagrEignRecord.agent_action_items.length > 0" offset-y open-on-hover close-on-click>
                        <template v-slot:activator="{ on }">
                          <v-btn class="primary ma-2" x-small v-on="on">Action</v-btn>
                        </template>
                        <v-list dense>
                          <v-list-item v-for="eign_action_item in hagrEignRecord.agent_action_items" :key="eign_action_item.text"
                            @click="eignActionClick(eign_action_item.action,hagrEignRecord.huov_encrid)">
                            <v-list-item-title>{{ eign_action_item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    
                      <btn_audit table="hspr" :encrid="huov.huov_encrid" :size=30 tooltip="audit of lines"/>
                      
                    </v-card-title>

                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>
                        </thead>


                        <tbody>

                          <tr v-for="(hagrRecord,k2) in hagrEignRecord.hagr" :key="k2">
                            <td> {{hagrRecord.hagr_dt}} </td>
                            <td>{{hagrRecord.fctitaal_oms}}</td>
                            <td align="right" style="vertical-align: top">{{hagrRecord.hagr_line }}</td>
                            <td align="right" style="vertical-align: top">{{hagrRecord.hagr_payment}}</td>
                            <td style="vertical-align: top">
                              <v-btn v-if="hagrRecord.hagr_rm === 'Yes'" text icon
                                @click="rmHagr(hagrRecord.hagr_encrid)">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan=5></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td><b>Balance {{hagrEignRecord.hagr_balance}}</b></td>
                            <td align="right"><b>{{hagrEignRecord.hagr_line_total}}</b></td>
                            <td align="right"><b>{{hagrEignRecord.hagr_payment_total}}</b></td>
                            <td></td>
                          </tr>
                        </tbody>

                      </template>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <addHagr ref="addHagr"></addHagr>
              <rmHagr ref="rmHagr"></rmHagr>
            </div>


              <!-- Remarks for host -->
              <v-row v-if="huov.my_villa_v2">
                <v-col cols="12" class="px-1">
                  <huovOpmEign :huov="huov"/>
                </v-col>
              </v-row>    
            <!-- changes stops here -->
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <huovCancel ref="huovCancel"></huovCancel>
      <huovRebook ref="huovRebook"></huovRebook>
      <m_attm ref="m_attm"></m_attm>
      <nott ref="nott"></nott>
      <huovGuestEmails ref="huovGuestEmails"></huovGuestEmails>
      <huovGuestSms ref="huovGuestSms"></huovGuestSms>
      <huovGuestWhap ref="huovGuestWhap"></huovGuestWhap>
      <huovHostSms ref="huovHostSms"></huovHostSms>
      <huovHostEmails ref="huovHostEmails"></huovHostEmails>
      <huovTravelParty ref="huovTravelParty"></huovTravelParty>
      <huovTravelPartyComposition ref="huovTravelPartyComposition"></huovTravelPartyComposition>
      <huovArrDep ref="huovArrDep"></huovArrDep>
      <mvHklrPayment ref="mvHklrPayment"></mvHklrPayment>
      <mvHklrPaymentTransfer ref="mvHklrPaymentTransfer"></mvHklrPaymentTransfer>
      <hklrAddCancellationInsurance ref="hklrAddCancellationInsurance"></hklrAddCancellationInsurance>
      <hklrNegativeBalanceToCredits ref="hklrNegativeBalanceToCredits"></hklrNegativeBalanceToCredits>
      <mvHctrPayment ref="mvHctrPayment"></mvHctrPayment>
      <mvHobo ref="mvHobo"></mvHobo>
      <huovExpExt ref="huovExpExt"></huovExpExt>
      <vstdBknDny ref="vstdBknDny"></vstdBknDny>
      <astdBknDny ref="astdBknDny"></astdBknDny>
      <huovInpt ref="huovInpt"></huovInpt>
      <huovOtaCode ref="huovOtaCode"></huovOtaCode>
      <huovOtaBooking ref="huovOtaBooking"></huovOtaBooking>
      <huovHandling ref="huovHandling"></huovHandling>
      <huovSendDocuGuest ref="huovSendDocuGuest"></huovSendDocuGuest>
      <huovSendDocuHost ref="huovSendDocuHost"></huovSendDocuHost>    
      <huovChat ref="huovChat"></huovChat>
      <huovAirbnbAlterationReq ref="huovAirbnbAlterationReq"></huovAirbnbAlterationReq>
      <huovKopieHogs ref="huovKopieHogs"/>
      <huovUpdatePeriod ref="huovUpdatePeriod" @updateData="updateData"/>
    </v-main>
  </v-app>
</template>

<script>
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    import nott from "@/components/nott.vue";
    import transferKlpt from "@/views/huov/klpt/transferKlpt.vue";
    import addHklr from "@/views/huov/hklr/addHklr.vue";
    import rmHklr from "@/views/huov/hklr/rmHklr.vue";
    import rmKlpt from "@/views/huov/klpt/rmKlpt.vue";
    import rmKltg from "@/views/huov/kltg/rmKltg.vue";
    import showHobo from "@/views/huov/hobo/showHobo.vue";
    import showHklrHkgm from "@/views/huov/hklr/hkgm/showHklrHkgm.vue";
    import showHsprHpgm from "@/views/huov/hspr/hpgm/showHsprHpgm.vue";
    import showHagrHagm from "@/views/huov/hagr/hagm/showHagrHagm.vue";
    import showHctrHcgm from "@/views/huov/hctr/hcgm/showHctrHcgm.vue";
    import updHklrTerms from "@/views/huov/hklr/updHklrTerms.vue";
    import updHoctTerms from "@/views/huov/hctr/updHoctTerms.vue";
    import addHctr from "@/views/huov/hctr/addHctr.vue";
    import rmHctr from "@/views/huov/hctr/rmHctr.vue";
    import huovGuestEmails from "@/views/huov/huovGuestEmails.vue";
    import huovGuestSms from "@/views/huov/huovGuestSms.vue";
    import huovGuestWhap from "@/views/huov/huovGuestWhap.vue";
    import huovHostSms from "@/views/huov/huovHostSms.vue";
    import huovHostEmails from "@/views/huov/huovHostEmails.vue";
    import huovTravelParty from "@/views/huov/huovTravelParty.vue";
    import huovTravelPartyComposition from "@/views/huov/huovTravelPartyComposition.vue";
    import huovArrDep from "@/views/huov/huovArrDep.vue";
    import mvHklrPayment from "@/views/huov/hklr/mvHklrPayment.vue";
    import mvHklrPaymentTransfer from "@/views/huov/hklr/mvHklrPaymentTransfer.vue";
    import hklrAddCancellationInsurance from "@/views/huov/hklr/addHklrCancellationInsurance.vue";
    import hklrNegativeBalanceToCredits from "@/views/huov/hklr/addHklrNegativeBalanceToCredits.vue";
    import mvHctrPayment from "@/views/huov/hctr/mvHctrPayment.vue";
    import addHspr from "@/views/huov/hspr/addHspr.vue";
    import rmHspr from "@/views/huov/hspr/rmHspr.vue";
    import addHagr from "@/views/huov/hagr/addHagr.vue";
    import rmHagr from "@/views/huov/hagr/rmHagr.vue";
    import rmHokp from "@/views/huov/hokp/rmHokp.vue";
    import addHokp from "@/views/huov/hokp/addHokp.vue";
    import mvHobo from "@/views/huov/hobo/mvHobo.vue";
    import huovExpExt from "@/views/huov/huovExpExt.vue";
    import vstdBknDny from "@/views/huov/vstdBknDny.vue";
    import astdBknDny from "@/views/huov/astdBknDny.vue";
    import huovInpt from "@/views/huov/huovInpt.vue";
    import huovOtaCode from "@/views/huov/huovOtaCode.vue";
    import huovOtaBooking from "@/components/huov/ota/bookingcom.vue";
    import huovHandling from "@/views/huov/huovHandling.vue";
    import huovSendDocuGuest from "@/views/huov/huovSendDocuGuest.vue";
    import huovSendDocuHost from "@/views/huov/huovSendDocuHost.vue";
    import huovCancel from "@/views/huov/huovCancel.vue";
    import huovRebook from "@/views/huov/huovRebook.vue";
    import m_attm from "@/components/m_attm.vue";
    import show_text from "@/components/show_text_lng.vue";
    import showReview from "@/views/task/customer_success/revw/onReview";
    import huov_hokl from '@/components/huov/cards/complaint.vue';
    import huov_hosm from '@/components/huov/cards/damages.vue';
    import huov_homb from '@/components/huov/cards/rebookings.vue';
    import huov_howz from '@/components/huov/cards/changes.vue';
    import huovOpmEign from '@/components/huov/cards/huovOpmEign.vue';
    import huovKopieHogs from '@/components/huov/cards/huovKopieHogs.vue';
    import huovUpdatePeriod from '@/components/huov/cards/huovUpdatePeriod.vue';
    import huovChat from '@/views/huov/huovChat.vue';
    import huovAirbnbAlterationReq from '@/views/huov/huovAirbnbAlterationReq.vue';
    import defNavBar from '@/components/ui/navbars/navbar.vue';
    import {bus} from "../../main";
    import mxmaxchar from '@/mixins/filtermaxchar';

 export default {
  components: {
    btn_audit,
    show_text, 
    showReview,    
    nott,
    m_attm,
    addHklr,
    transferKlpt,
    rmHklr,
    rmKlpt,
    rmKltg,
    showHobo,
    showHklrHkgm,
    showHsprHpgm,
    showHagrHagm,
    showHctrHcgm,
    updHklrTerms,
    updHoctTerms,
    addHctr,
    rmHctr,
    rmHokp,
    addHokp,
    addHspr,
    rmHspr,
    addHagr,
    rmHagr,
    huovGuestEmails,
    huovGuestSms,
    huovGuestWhap,
    huovHostSms,
    huovHostEmails,
    huovTravelParty,
    huovTravelPartyComposition,
    huovArrDep,
    mvHklrPayment,
    mvHklrPaymentTransfer,
    hklrAddCancellationInsurance,
    hklrNegativeBalanceToCredits,
    mvHctrPayment,
    mvHobo,
    huovExpExt,
    vstdBknDny,
    astdBknDny,
    huovInpt,
    huovOtaCode,
    huovOtaBooking,
    huovHandling,
    huovSendDocuGuest,
    huovSendDocuHost,
    huovChat,
    huovAirbnbAlterationReq,
    huovCancel,
    huovRebook,
    huov_hokl,
    huov_hosm,
    huov_homb,
    huov_howz,
    huovOpmEign,
    huovKopieHogs,
    huovUpdatePeriod,
    defNavBar
  },
  props: ['huov_encrid'],
  data() {
    return {
      stat_codeKeuzes: [],
      huov: {
        huov_naam: '',
        stat_code: '',
        action_items: [],  /* moet pre defined ivm length check */
        hspr_inpt: [], /* moet pre defined ivm length check */
        hagr_eign: [],
        product_partner: {
            ikpt_naam: ""
        }
      },
      getPlanVar: '',
      planMaand: [],
      planCode: '',
      showPriceExplenation: false,
      snackbar: false,
      snackbarMessage: '',
      huov_hosm:[],
      huov_hogr:[],
      huov_revw:[],
      hosm_exposed:'',
      declinedCancellationInsurance: false,
      isCopied: '',
      xdots: '',
      processing: false,
    }
  },
  mounted() {
    this.getHuov();
  },
  mixins: [mxmaxchar],
  created(){ // set up event bus listener here on created event
    bus.$on("closeDialog", (data) => {  
      if(data == "huov_m_attm"){
        this.getHuov(); // reload this screen after attachment dialog is closed
      }
    }),
    bus.$on("addNote", (data) => {
       this.huov.nott_aant += data;
    });        
    bus.$on("reloadHuov", (data) => {                        
      if(data == "travelparty" || data == "sendClaim"){
        this.getHuov(); // reload this screen after travelparty dialog is closed
      }
    }),
    bus.$on("updateReviewList", (data) => {
      if (data != null) {              
        this.huov_hogr[0].status = data.status;
        this.huov_hogr[0].assigned_display_name = data.display_name;
        this.huov_hogr[0].revw_score = data.score;
        this.huov_hogr[0].revw_score_color = data.color_code;
        this.huov_hogr[0].revw_text = data.gastenboek;
        this.huov_hogr[0].revw_reaction = (data.reaction_vfy.trim() !== '');
      }
    });    
  },
  computed: {},      
  methods: {
    getArrayLength(arr){
       // Getting the length property of an empty array gives an error. You have to read it like this.
       try{
          return arr.length;
       } catch(err){
          return 0;
       }
    },
    isBookingOngoingOrCompleted(){
       // Determines if a booking is ongoing or has been completed
       // Returns true if the booking has started (ongoing or completed), false if not yet started
       if (!this.huov || !this.huov.huov_van_dat) {
          return false;
       }
       
       const today = new Date();
       today.setHours(0, 0, 0, 0); // Reset time to midnight for date-only comparison
       
       const startDate = new Date(this.huov.huov_van_dat);
       startDate.setHours(0, 0, 0, 0);
       
       // Return true if current date is > start date (booking has started or completed)
       // On the start date itself it will be still possible to confirm the under occupancy
       return today > startDate;
    },
    updateData(){
      this.getHuov();
    },
    getHuov(){
      this.$axios
        .post("ares/json/ares/huov/getHuov.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuov"
          },
          getHuov: {
            huov_encrid: this.huov_encrid
        }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuov;
            document.title = 'Booking ' + res.data.getHuov.huov_code;
            this.huov_hogr = res.data.getHuov.huov_hogr;
            this.huov_revw = res.data.getHuov.huov_revw;
            this.declinedCancellationInsurance = res.data.getHuov.declinedCancellationInsurance;

          }
        });
        //this.getHosm(); 
    },
    showReaction(table, encrid, header, type) {
      //console.log('show reaction', key);
      this.$axios
          .post("ares/json/ares/huis/revw/getReviewTexts.p", {
              header: {
                  token: this.$session.get("ARES"),
                  clientSessionId: this.$session.id(),
                  request: "getReviewTexts"
              },
              getReviewTexts: {
                  table: table,
                  encrid: encrid,
                  type: type,
              }
          })
          .then(res => {
              if (res.data.error) {
                  console.log(res.data.error);
              } else {
                  this.showText(header, res.data.getReviewTexts.Texts, res.data.getReviewTexts.open_tab);
              }
          })
          .finally(() => {
          });
    },       
    handleDeclinedCancellationInsuranceChange() {
      this.processing=true
      this.$axios
          .post("ares/json/ares/huov/updHuovAnnVerz.p", {
              header: {
                  token: this.$session.get("ARES"),
                  clientSessionId: this.$session.id(),
                  request: "updHuovAnnVerz"
              }, //253700270
              updHuovAnnVerz: {
                  ann_verz: this.huov.declinedCancellationInsurance,
                  huov_encrid: this.huov_encrid
              }
          })
          .then(res => {
              this.xdots = '•';	
              if (res.data.error) {
                  console.log(res.data.error);
                  this.xdots = '';
                  this.processing=false
              } 
              else {
                const xinterval = setInterval(() => {
                  this.xdots += '•';
                }, 200);
                setTimeout(() => {
                  clearInterval(xinterval);
                  this.declinedCancellationInsurance = false;
                }, 1500);
              }
          })
    },
    getHosmHeaders(){
      return [
          { text: "Created", value: "created", sortable: false, width: "12%"},
          { text: "Summary", value: "summary", sortable: false},
          { text: "Amount", value: "claimedAmount", align: "end", sortable: false, width: "11%"},
          { text: "Status", value: "hosm_smst_display", sortable: false},
          { text: "Assigned to", value: "gebr_naam", sortable: false},
          { sortable: false, align: "start"},
          { sortable: false, align: "start", width: "16%"},
        ];
    },       
    getHogrHeaders() {
        return [
            { text: "Created", value: "revw_date_created", align: "start", width: "12%"},
            { text: "Assigned", value: "assigned", align: "start", width: "12%" },
            { text: "Score", value: "revw_score", sortable: false, align: "center", width: "5%" },
            { text: "Lng", value: "revw_language_code", sortable: false, align: "center", width: "5%" },
            { text: "Review", value: "revw_text", sortable: false, align: "start", width: "45%" },
            { text: "Status", value: "status", sortable: false, align: "start", width: "5%" },
            { text: "Re.VFY", value: "revw_reaction", sortable: false, align: "start", width: "5%" },
            { text: "", value: "upd", sortable: false, align: "center", width: "5%" }
        ];
    },    
    actionClick(action) {
      switch(action) {
        case "nott" : this.$refs.nott.open("huov", this.huov_encrid, "all"); break;
        case "m_attm" : this.$refs.m_attm.open('huov', this.huov.huov_code, '', 'huov', this.huov_encrid, 0); break;        
        case "Cancel" : this.$refs.huovCancel.open(this.huov_encrid); break;
        case "Rebook" : this.$refs.huovRebook.open(this.huov_encrid); break;
        case "huovGuestEmails" : this.$refs.huovGuestEmails.open(this.huov_encrid); break;
        case "huovHostEmails" : this.$refs.huovHostEmails.open(this.huov_encrid); break;
        case "huovExpExt" : this.$refs.huovExpExt.open(this.huov_encrid); break;
        case "vstdBknDny" : this.$refs.vstdBknDny.open(this.huov_encrid); break;
        case "astdBknDny" : this.$refs.astdBknDny.open(this.huov_encrid); break;
        case "huovGuestSms" : this.$refs.huovGuestSms.open(this.huov_encrid); break;
        case "huovGuestWhap" : this.$refs.huovGuestWhap.open(this.huov_encrid); break;
        case "mvHobo" : this.$refs.mvHobo.open(this.huov_encrid); break;
        case "huovSendDocuGuest" : this.$refs.huovSendDocuGuest.open(this.huov_encrid); break;
        case "huovSendDocuHost" : this.$refs.huovSendDocuHost.open(this.huov_encrid); break;
        case "huovChat" : this.$refs.huovChat.open(this.huov.huov_encrid_chat, this.huov.klnt_voornaam, this.huov.klnt_achternaam, this.huov.huov_code, this.huov.klnt_email, this.huov.klnt_tel1, this.huov.klnt_taal_code); break;
        case "huovAirbnbAlterationReq" : this.$refs.huovAirbnbAlterationReq.open(this.huov_encrid); break;
        case "huovHostSms" : this.$refs.huovHostSms.open(this.huov_encrid); break;
        case "feratelPdf": this.feratelPdf(this.huov_encrid); break;
        case "CopyTravelParty" : this.$refs.huovKopieHogs.openDialog(this.huov_encrid); break;
        case "huovUpdatePeriod" : this.$refs.huovUpdatePeriod.openDialog(this.huov_encrid); break;
      }
    },
    klntActionClick(action,huov_encrid) {
      switch(action) {
        case "hklrAddLine" : this.$refs.addHklr.open(huov_encrid,'Line'); break;
        case "hklrAddKltg" : this.$refs.addHklr.open(huov_encrid,'Kltg'); break;
        case "hklrAddKlpt" : this.$refs.addHklr.open(huov_encrid,'Klpt'); break;
        case "hklrTransferKlpt": this.$refs.transferKlpt.open(huov_encrid); break;
        case "hklrAddHkbo" : this.$refs.addHklr.open(huov_encrid,'Hkbo'); break;
        case "hklrShowHobo" : this.$refs.showHobo.open(huov_encrid); break;
        case "hklrAddPayment" : this.$refs.addHklr.open(huov_encrid,'Payment'); break;
        case "hklrUpdTerms" : this.$refs.updHklrTerms.open(huov_encrid); break;
        case "hklrShowGbmt" : this.$refs.showHklrHkgm.open(huov_encrid, 'Verblijf'); break;
        case "hklrShowGbmtBooking" : this.$refs.showHklrHkgm.open(huov_encrid, 'Boeking'); break;
        case "mvHklrPayment" : this.$refs.mvHklrPayment.open(huov_encrid); break;
        case "mvHklrPaymentTransfer" : this.$refs.mvHklrPaymentTransfer.open(huov_encrid); break;
        case "hklrAddCancellationInsurance" : this.$refs.hklrAddCancellationInsurance.open(huov_encrid, 'insurance'); break;
        case "hklrNegativeBalanceToCredits" : this.$refs.hklrNegativeBalanceToCredits.open(huov_encrid, 'negativeBalance'); break;
      }
      
    },
    inptActionClick(action,huov_encrid) {
      switch(action) {
        case "hsprShowGbmt" : this.$refs.showHsprHpgm.open(huov_encrid, 'Verblijf'); break;
        case "hsprShowGbmtBooking" : this.$refs.showHsprHpgm.open(huov_encrid, 'Boeking'); break;
        case "hsprAddLine" : this.$refs.addHspr.open(huov_encrid,'Line'); break;
      }      
    },
    eignActionClick(action,huov_encrid) {
      console.log('action ', action, huov_encrid) 
      switch(action) {
        case "hagrShowGbmt" : this.$refs.showHagrHagm.open(huov_encrid, 'Verblijf'); break;
        case "hagrShowGbmtBooking" : this.$refs.showHagrHagm.open(huov_encrid, 'Boeking'); break;
        case "hagrAddLine" : this.$refs.addHagr.open(huov_encrid,'Line'); break;
      }      
    },    
    hoctActionClick(action,hoct_encrid) {
      switch(action) {
        case "hctrAddLine" : this.$refs.addHctr.open(hoct_encrid,'Line'); break;
        case "hctrAddPayment" : this.$refs.addHctr.open(hoct_encrid,'Payment'); break;
        case "hoctUpdTerms" : this.$refs.updHoctTerms.open(hoct_encrid); break;
        case "hctrShowGbmt" : this.$refs.showHctrHcgm.open(hoct_encrid, 'Verblijf'); break;
        case "hctrShowGbmtBooking" : this.$refs.showHctrHcgm.open(hoct_encrid, 'Boeking'); break;
        case "mvHctrPayment" : this.$refs.mvHctrPayment.open(hoct_encrid); break;
      }      
    },
    feratelPdf(huov_encrid) {
        this.$axios.post("ares/json/ares/huov/feratelPdf.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "feratelPdf"
            },
            feratelPdf: {
                huov_encrid: huov_encrid,
            }
        }).then(res => {
            if (res.data.error) {
                console.log(res.data.error);
            } else {
                window.open(res.data.feratelPdf.filename, '_blank');
                // this.showText(header, res.data.getReviewTexts.Texts, res.data.getReviewTexts.open_tab);
            }
        });
    },
    async copyUrlToClipboard(text) {
      // navigator will not work in DEV which is HTTP   
      text = `https://mybooking.villaforyou.com/${text}`   
      if (window.isSecureContext && navigator.clipboard) {
        await navigator.clipboard.writeText(text)
      } else {
        await this.unsecuredCopyToClipboard(text)
      }
      this.isCopied = 'Copied!'
      setTimeout(() => { this.isCopied = '' }, 3000)
    },
    async unsecuredCopyToClipboard(text) {
      // create dummy text area
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      // add dummy element and select it
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy'); // deprecated but it still works, for DEV this is acceptable
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      // kill dummy element
      document.body.removeChild(textArea);      
    },     
    loginMyBooking(klnt_encrid) {
      // get a new encrypted rowid for the login. The login checks if the encrid is older than 5 mins
      // if it is, it wil not login. If you have this page open longer than 5 mins any login attempt will fail,
      // hence the creation of a new encrid for klnt. The encrid for this page is valid for one hour, that's the error.
      this.$axios.post("ares/json/ares/klnt/encryptRowidForLoginV3.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getEncryptedRowidForLogin",
        },
        getEncryptedRowidForLogin: {
          klnt_encrid: klnt_encrid,
        },
      })
      .then((res) => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          window.open(`https://mybooking.villaforyou.com/from-ares/${res.data.getEncryptedRowidForLogin.klnt_encrid}`); 
        }
      });
    },        
    showText(header, texts, tab) {
        this.$refs.showtext.open(header, texts, tab);
    },
    showReview(review) {
        this.$refs.showreview.open(review);
    },         
    rmHklr(hklr_encrid) {
       this.$refs.rmHklr.open(hklr_encrid);
    },
    rmHspr(hspr_encrid) {
       this.$refs.rmHspr.open(hspr_encrid);
    },
    rmHagr(hagr_encrid) {
       this.$refs.rmHagr.open(hagr_encrid);
    },
    rmKlpt(klpt_encrid) {
       this.$refs.rmKlpt.open(klpt_encrid);
    },
    rmKltg(kltg_encrid) {
       this.$refs.rmKltg.open(kltg_encrid);
    },
    rmHctr(hctr_encrid) {
       this.$refs.rmHctr.open(hctr_encrid);
    },
    rmHokp(hokp_encrid) {
       this.$refs.rmHokp.open(hokp_encrid);
    },
    addHokp(huov_encrid) {
       this.$refs.addHokp.open(huov_encrid);
    },
    approveUnderOccupancy(huov_encrid) {
      this.$axios.post("ares/json/ares/huov/approveUnderOccupancy.p", {
          header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "approveUnderOccupancy"
          },
          approveUnderOccupancy: {
              huov_encrid: huov_encrid,
          }
      }).then(res => {
          if (res.data.error) {
              console.log(res.data.error);
          } else {
              this.snackbarMessage = 'Under occupancy approved';
              this.snackbar = true;
              this.getHuov();
          }
      });
    },
    makeHkrdTable(hkrd) {
      let cTemp = "";
       hkrd.forEach(record => {
         cTemp += `<div><div class="row no-gutters"><div class="col-6 pl-5 pr-1 font-weight-light" style="white-space: nowrap;">${record.hkrd_oms}</div><div class="col-6 pl-1 pr-0 font-weight-light" align="right">${record.hkrd_line}</div></div></div>`;
       });
       return cTemp;
    }
  }
};

</script> 

<style scoped>
  .row-pointer {
    cursor: pointer;
  }
  .button-margin-lr{
    margin-left: 4px;
    margin-right: 4px;
  }
  .button-margin-l{
    margin-left: 4px;
  }  
  .button-margin-r{
    margin-right: 6px;
  }  
  .td_markup {
    vertical-align: top;
    border-top: 5px solid transparent;
    font-size: 12px !important;
    /* trick to add padding to a TD element (which is not possible with CSS normally) */
   }

  .logo_row_2 {
    cursor: pointer !important;
  }    
  .text_markup {
    font-size: 14px !important;
  }
  .refundable-text {
    color: dodgerblue;
    background-color: rgba(30, 144, 255, 0.2);
    border: 1px solid dodgerblue;
    border-radius: 8px;
    height: 30px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    line-height: 1;
  }
  .grid-item-error {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid red;
        color: red;
        cursor: default;
    }
    .grid-item {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid darkgrey;
        color: darkgrey;
        cursor: pointer;
        height: 30px !important;
        width: 30px !important;
    }
    .grid-item-warning {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid orange;
        color: orange;
        cursor: default;
    }

    .grid-item-rebooking {
        background: transparent !important;
        font-size: 22px !important;
        font-weight: 600 !important;
        border: 2px solid dodgerblue;
        color: dodgerblue;
        cursor: default;
    }

    .grid-item-change {
        background: transparent !important;
        font-size: 22px !important;
        font-weight: 600 !important;
        border: 2px solid #FF8800;
        color: #FF8800;
        cursor: default;
    }

    .grid-item-warning-test {
        background: transparent !important;
        font-size: 16px !important;
        font-weight: 800 !important;
        border: 2px solid orange;
        color: orange;
        cursor: default;
    }

    .grid-item-ok {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid green;
        color: green;
        cursor: default;
    }
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
    .audit {
        cursor: pointer;
    }
    .avatar-refund {
      font-size: 16px !important; /* Adjust as needed */
      border-width: 0.5px !important;
    }
</style>